import {
  Box,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Link as MuiLink,
  Typography,
} from '@mui/material';
import {useFlags} from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router-dom';

import BookOpenIcon from '../../assets/book-open.svg';
import LifeBuoyIcon from '../../assets/life-buoy.svg';
import PlayCircleIcon from '../../assets/play-circle.svg';
import ShieldIcon from '../../assets/shield.svg';
import SparklesIcon from '../../assets/sparkles.svg';

export const ResourcesMenu = React.memo(
  ({anchorEl, changelogUnseenCount, onClose, onMenuClick}) => {
    const flags = useFlags();
    return (
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
        disableAutoFocusItem={true}
        id="menu-appbar"
        keepMounted
        onClose={onClose}
        open={Boolean(anchorEl)}
        slotProps={{
          paper: {
            style: {
              border: '1px solid #067a6f',
              borderRadius: '3px',
              boxShadow: '2px 2px 4px 0px rgba(0,0,0,0.25)',
              width: '257px',
            },
          },
        }}
        sx={{mt: '28px'}}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
      >
        <MenuItem
          id="get-help-button"
          key="customer-support"
          onClick={() => onMenuClick('help')}
          sx={{height: 40}}
        >
          <ListItemIcon>
            <img height={16} src={LifeBuoyIcon} width={16} />
          </ListItemIcon>
          <Typography color="#052E28">Customer Support</Typography>
        </MenuItem>

        <Box sx={{mx: 1, pb: 0.5, pt: 1.25}}>
          <Typography sx={{color: '#34A290', fontSize: 14, fontWeight: 600}}>
            Resources
          </Typography>
          <Divider sx={{borderColor: '#B8D9CC', mt: 0.5}} />
        </Box>

        <MenuItem
          component={MuiLink}
          href="https://headwayapp.co/inscope-changelog"
          key="changelog"
          onClick={() => onMenuClick('changelog')}
          sx={{height: 40}}
          target="_blank"
        >
          <ListItemIcon>
            <img height={16} src={SparklesIcon} width={16} />
          </ListItemIcon>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Typography color="#052E28">{"What's New"}</Typography>
            {changelogUnseenCount > 0 && (
              <Box
                sx={{
                  alignItems: 'center',
                  backgroundColor: '#EE2E2E',
                  borderRadius: '10px',
                  color: '#fff',
                  display: 'flex',
                  fontSize: 11,
                  fontWeight: 600,
                  height: 20,
                  justifyContent: 'center',
                  minWidth: 20,
                  px: 0.5,
                }}
              >
                {changelogUnseenCount}
              </Box>
            )}
          </Box>
        </MenuItem>

        {flags.disclosureGuidance && (
          <MenuItem
            component={Link}
            key="disclosure-library"
            onClick={() => onMenuClick('disclosure-library')}
            sx={{height: 40}}
            target="_blank"
            to={'/disclosure-library'}
          >
            <ListItemIcon>
              <img height={16} src={BookOpenIcon} width={16} />
            </ListItemIcon>
            <Typography color="#052E28">Disclosure Library</Typography>
          </MenuItem>
        )}

        <MenuItem
          component={MuiLink}
          href="https://www.inscopehq.com/product-demo"
          key="product-demos"
          onClick={() => onMenuClick('product-demos')}
          sx={{height: 40}}
          target="_blank"
        >
          <ListItemIcon>
            <img height={16} src={PlayCircleIcon} width={16} />
          </ListItemIcon>
          <Typography color="#052E28">Product Demos</Typography>
        </MenuItem>

        <MenuItem
          component={MuiLink}
          href="https://www.inscopehq.com/terms"
          key="legal"
          onClick={() => onMenuClick('legal')}
          sx={{height: 40}}
          target="_blank"
        >
          <ListItemIcon>
            <img height={16} src={ShieldIcon} width={16} />
          </ListItemIcon>
          <Typography color="#052E28">Legal</Typography>
        </MenuItem>
      </Menu>
    );
  }
);

ResourcesMenu.displayName = 'ResourcesMenu';

ResourcesMenu.propTypes = {
  anchorEl: PropTypes.object,
  changelogUnseenCount: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onMenuClick: PropTypes.func.isRequired,
};
